export interface ConversionClicksStatsClicks {
  click_number: ConversionClickClickNumber
  total_click_number: number
}

export interface ConversionClickClickNumber {
  nombreClick: ConversionClicksNumberClicks[]
}

export interface ConversionClicksNumberClicks {
  eventCount: string
  dateHour: string
  browser: string
  pagePath: string
  city: string
  country: string
  platformDeviceCategory: string
  sessionSource: string
}

export const initialStatsConversionClicksClicks: ConversionClicksStatsClicks = {
  total_click_number: 0,
  click_number: {
    nombreClick: [
      {
        eventCount: '',
        dateHour: '',
        browser: '',
        pagePath: '',
        city: '',
        country: '',
        platformDeviceCategory: '',
        sessionSource: '',
      },
    ],
  },
}

export type BrowsersType = "chrome" | "edge" | "firefox" | "opera";
export const browsers: BrowsersType[] = ["chrome", "edge", "firefox", "opera"];

